import { ActionTypes } from '../actions';

export const INITIAL_STATE = {
  done: false,
  displayErrors: false,
};

const SurveyReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.UPDATE_SURVEY:
      return {
        ...state,
        ...action.payload,
      };
    case ActionTypes.COMPLETED_SURVEY:
      return {
        ...state,
        done: true,
        displayErrors: false,
      };
    case ActionTypes.REVISIT_SURVEY:
      return {
        ...state,
        done: false,
        displayErrors: false,
      };
    case ActionTypes.SHOW_SURVEY_ERRORS:
      return {
        ...state,
        displayErrors: true,
      };
    case ActionTypes.CLEAR_SURVEY:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default SurveyReducer;
